const SidebarState = {
    HIDDEN: "hidden",
    INFO: "info",
    CONFIGURE: "configure",
    BUILDER: "builder",
    NODEINFO: "nodeinfo",
  };
  
export default SidebarState;